import React, { Fragment, useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { chaveArmazenamentoIdSessao } from '../../../shared/utils/Constantes'
import { atualizarDadosAcesso } from '../LoginManager'
import { configureEnvironment } from '../../../config/env'
import { formatarUrlComSessionId } from '../../../shared/utils/Formatacao'

const Login = ({
    atualizarDadosAcesso,
    autenticado,
    acessoNegado,
    loginExterno
}) => {

    const parametrosPesquisa = new URLSearchParams(window.location.search)
    const idSessao = parametrosPesquisa.get('sessionId')

    // eslint-disable-next-line react-hooks/exhaustive-deps
    async function AtualizarDadosDeAcesso() {
        let tokenAcesso = idSessao ?? localStorage.getItem(chaveArmazenamentoIdSessao)
        await atualizarDadosAcesso(tokenAcesso)
    }

    useEffect(() => {
        AtualizarDadosDeAcesso();
    }, [idSessao, atualizarDadosAcesso, AtualizarDadosDeAcesso])

    const criarRedirect = () => {
        if (acessoNegado) {
            if (loginExterno) {
                return <Redirect to={'/login-customizado'} />;
            }
            else if (loginExterno === false) {
                return <Route component={() => {
                    window.location.href = formatarUrlComSessionId(
                        configureEnvironment().REACT_APP_URL_PAGINA_INICIAL_MY_PARDINI);
                    return null;
                }} />;
            }
            else return <Redirect to={'/acesso-negado'} />;
        }

        if (!autenticado) return null;

        return <Redirect to={"/amostras-cadastradas"} />;
    }

    const redirect = criarRedirect();

    return (
        <Fragment>
            {redirect}
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        autenticado: state.login.usuarioAutenticado,
        acessoNegado: state.login.acessoNegado,
        loginExterno: state.login.loginExterno
    }
}

const mapDispatchToProps = {
    atualizarDadosAcesso: idSessao => atualizarDadosAcesso(idSessao)
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login)

